import { useSize } from '@modules/size/composables';
import { useColor } from '@modules/color/composables';

/**
 *
 * @param {string} id
 * @returns {{ selectedColor: import('vue').WritableComputedRef<Color | null>,
 * selectedColorId: SelectedColorId, selectedSize: import('vue').WritableComputedRef<Size | null>,
 * selectedSizeId: SelectedSizeId }}
 */
export function useTraits(id) {
  const { selectedColor, selectedColorId } = useColor(id);
  const { selectedSize, selectedSizeId } = useSize(id);

  return {
    selectedColor,
    selectedSize,
    selectedColorId,
    selectedSizeId,
  };
}

export default useTraits;
